import React from 'react'
import Logo from '../../assets/images/new-logo.png'
import classes from './footer.module.css'
import gridClasses from '../../styles/grid.module.css'
import tw from '../../assets/images/tw.svg'
import ig from '../../assets/images/ig.svg'
import fb from '../../assets/images/fb.svg'
import linkedin from '../../assets/images/linkedin.svg'
import youtube from '../../assets/images/youtube.svg'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <div className={classes.footer}>
            <div
                className={`${gridClasses.container} ${gridClasses.containerTransparent} ${classes.footerContainer}`}
            >
                <div className={classes.footerLogoArea}>
                    <img src={Logo} className={classes.footerLogoImage} />
                    <p className={classes.footerLogoText}>
                        Never miss an update. Keep in touch via our social media
                        handles below.
                    </p>
                    <div className={classes.footerSMIcons}>
                        <a
                            target="_blank"
                            className={classes.footerSMIconLink}
                            href="https://www.instagram.com/smeupturn/?hl=en"
                        >
                            <img
                                src={ig}
                                alt="Instagram Icon"
                                className={classes.footerSMIcon}
                            />
                        </a>
                        <a
                            target="_blank"
                            className={classes.footerSMIconLink}
                            href="https://web.facebook.com/SmeUpturn/"
                        >
                            <img
                                src={fb}
                                alt="Facebook Icon"
                                className={classes.footerSMIcon}
                            />
                        </a>
                        <a
                            target="_blank"
                            className={classes.footerSMIconLink}
                            href="https://mobile.twitter.com/smeupturn?lang=en"
                        >
                            <img
                                src={tw}
                                alt="Twitter Icon"
                                className={classes.footerSMIcon}
                            />
                        </a>
                        <a
                            target="_blank"
                            className={classes.footerSMIconLink}
                            href="https://ng.linkedin.com/company/smeupturn"
                        >
                            <img
                                src={linkedin}
                                alt="LinkedIn Icon"
                                className={classes.footerSMIcon}
                            />
                        </a>
                        <a
                            target="_blank"
                            className={classes.footerSMIconLink}
                            href="https://www.youtube.com/channel/UC2MZwZg7nmP8X4zEUf4nDWA"
                        >
                            <img
                                src={youtube}
                                alt="Youtube Icon"
                                className={classes.footerSMIcon}
                            />
                        </a>
                    </div>
                </div>
                <div className={classes.footerLinksGrid}>
                    <div>
                        <h3 className={classes.footerLinksHeader}>Company</h3>
                        <Link to={'/about-us'} className={classes.footerLink}>
                            About Us
                        </Link>
                        <Link to={'/blog'} className={classes.footerLink}>
                            Blog
                        </Link>
                    </div>
                    <div>
                        <h3 className={classes.footerLinksHeader}>Learning</h3>
                        <Link
                            to={'/app/browse/courses'}
                            className={classes.footerLink}
                        >
                            All Courses
                        </Link>
                        <Link
                            to={'/app/browse/classes'}
                            className={classes.footerLink}
                        >
                            All Classes
                        </Link>
                        <Link to={'/plans'} className={classes.footerLink}>
                            Subscription Plans
                        </Link>
                        <Link
                            to={'/business'}
                            className={`${classes.footerLink} ${classes.footerLinkBlue}`}
                        >
                            Upturn for Business
                        </Link>
                    </div>
                    <div>
                        <h3 className={classes.footerLinksHeader}>Support</h3>
                        <p
                            className={classes.footerLink}
                            style={{ lineHeight: 2 }}
                        >
                            For inquiries, please call 07061063850
                        </p>
                        {/* <p className={classes.footerLink}>Payments</p> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
